'use client';

import { useEffect } from 'react';

import ErrorBlock from '@campaign-manager/app/ui/react/features/error/ErrorBlock';
import ErrorPageLayout from '@campaign-manager/app/ui/react/features/error/ErrorPage/ErrorPageLayout';

export default function NotFound() {
  useEffect(() => {
    console.error('Page not found', window.location.href);
  }, []);

  return (
    <ErrorPageLayout>
      <ErrorBlock
        heroTitle="404"
        title="The page you are looking for doesn't exist or another error occurred"
        primaryCta={{
          label: 'Back to home',
          href: '/',
        }}
      />
    </ErrorPageLayout>
  );
}
